module.exports = __webpack_public_path__ + "img/logo.e31215b0.png";